export default "__VITE_ASSET__DiYVbFO9__"